import { useEffect } from "react";

const DEFAULT_TITLE =
  "MenuzAI — Cardápio Digital com Inteligência Artificial";

/**
 * Set document.title for the lifetime of the mounted route.
 * Falls back to the app default on unmount.
 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous || DEFAULT_TITLE;
    };
  }, [title]);
}
